<div class="section-title-container">
    <div class="section-heading">
        <div class="section-title">Manage the project team
        </div>
        <div class="dds-label greyed-out">
            Here you can manage the team members linked to the project
        </div>
    </div>
</div>

<div class="dds-label greyed-out dds-mb-1">
    Owner
</div>

<dds-button [theme]="buttonOptions.theme" [kind]="buttonOptions.kind" [size]="buttonOptions.size"
    [width]="buttonOptions.width" [icon]="buttonOptions.icon" [isIconLeft]="buttonOptions.isIconLeft"
    [role]="buttonOptions.role" [isInverse]="buttonOptions.isInverse" [isColorBg]="buttonOptions.isColorBg"
    [isLoading]="buttonOptions.isLoading" [ariaLabel]="buttonOptions.ariaLabel"
    [customClass]="buttonOptions.customClass" (clicked)="buttonClick()">David Bon</dds-button>